<template>
    <div class="tab_content">
        <span>{{ activeFormatInThemeTab.name }}</span>
        <div class="tab_grid">
            <div class="gallery_grid" :key="dataLoaded">
                <div
                    v-for="(page, index) in projectPages"
                    :key="index"
                    class="gallery_grid_item"
                    :style="boxStyle()"
                >
                    <div
                        :style="{ backgroundImage: `url(${page.thumbnailUrl})` }"
                        class="gallery_grid_item_img"
                        @click="checkIfPageHasElements(page)"
                    />
                </div>
                
            </div>
            <button @click="showProjects">{{ $t('editorTabProjectsBack') }}</button>
        </div>
        <Modal 
            v-if="showModal"
            @close="showModal = false"
            :showModal="false"
        >
            <template v-slot:header>
                <strong>{{ $t('editorTabProjectsWarning') }}</strong>
            </template>
            <template v-slot:body>
                {{ $t('editorTabProjectsOverwrite') }}
            </template>
            <template v-slot:footer>
                <button @click="showModal = false" class="modal_cancel-btn">{{ $t('editorCancel') }}</button>
                <button
                    class="modal_action-btn"
                    @click="addPagelements(pageToInsert)"
                >{{ $t('editorTabProjectsApplyNewLayout') }}</button>
            </template>
        </Modal>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import { RepositoryFactory } from '../../../repositories/repositoryFactory.js';
    const ProjectRepository = RepositoryFactory.get('projects');
    import { uuid } from 'vue-uuid';
    import Modal from '@/components/Global/Modal.vue';
    import { migarateToLatest } from '../../../js/migrator.js';
    import { qrSvg } from '../../../js/qrCodeSvg';

    export default {
        data() {
            return {
                projectPages: [],
                dataLoaded: 0,
                showModal: false,
                pageToInsert: null
            }
        },
        computed: {
            ...mapGetters([
                'getTemplateFormat',
                'getProject',
                'getCurrentPage',
                'getPages',
                'getSessionDetails',
                'getActivePageId',
                'getPlaceholders'
            ]),
            ...mapState([
                'sessionToken',
                'activeProjectInThemeTab',
                'activeFormatInThemeTab'
            ])
        },
        methods: {
            boxStyle() {
                const ratio = this.activeFormatInThemeTab.width / this.activeFormatInThemeTab.height;
                let widthNew, heightNew;

                if (ratio > 1) {
                    widthNew = 115;
                    heightNew = 115 / ratio;
                } else if (ratio < 1) {
                    heightNew = 155;
                    widthNew = 155 * ratio;
                } else {
                    heightNew = 115;
                    widthNew = 115;
                }

                return `width: ${widthNew}px; height: ${heightNew}px;`
            },
            showProjects() {
                // this.$store.dispatch('SET_ACTIVE_PROJECT_IN_THEME_TAB', null)
                this.$store.dispatch('SET_ACTIVE_THEME_TAB', 'activeFormatProjects')
            },
            checkIfPageHasElements(page) {
                const pageEmpty = this.getPages.find(page => page.content.isActive === true).content.elements.length > 0 ? false : true;
                pageEmpty ? this.addPagelements(page) :  (this.showModal = true, this.pageToInsert = page ); 
            },
            addPagelements(page) {
                const pageContent = migarateToLatest(page.content);
                this.$store.dispatch('CLEAR_PAGE');
                this.$store.dispatch('SET_PAGE_RADIUS', pageContent.pageRadius);
                this.$store.dispatch('SET_PAGE_COLOR', pageContent.pageColor);
                this.$store.dispatch('LOCK_PAGE', pageContent.isLocked);
                this.$store.dispatch('SET_PAGE_BACKGROUND', {
                    ...pageContent.backgroundImage
                });
                this.$store.dispatch('ELEMENTS_CHANGING', true);

                const elements = pageContent.elements;
                // elements.forEach(element => {
                //     if (this.getSessionDetails.mode === 'user') {
                //         const isPlaceholderElement = Object.keys(element).includes('placeholder');

                //         if (isPlaceholderElement) {
                //             const isPlaceholderSet = element.placeholder.hasPlaceholder;

                //             if (isPlaceholderSet) {
                //                 const placeholderSystemName = element.placeholder.placeholderSystemName;

                //                 const placeholderValue = this.getSessionDetails.placeholderValues[placeholderSystemName].value;

                //                 const content = placeholderValue !== null ? placeholderValue : element.content;

                //                 element = {
                //                     ...element,
                //                     content
                //                 }
                //             }
                //         }
                //     }
                    

                //     const hasLockedValue = Object.keys(element).includes('isLocked');
                //     const hasNewTransforms = Object.keys(element).includes('newTransforms');
                //     const isLocked = hasLockedValue ? element.isLocked : false;
                //     const newTransforms = hasNewTransforms ? element.newTransforms : false;

                //     const elData = {
                //         ...element,
                //         pageId: this.getActivePageId,
                //         id: uuid.v1(),
                //         isLocked,
                //         newTransforms
                //     };
                //     const payload = {
                //         elData,
                //         fromProject: true,
                //         elementFromPage: true
                //     };
                    
                    
                //     this.$store.dispatch('ADD_PAGE_ELEMENT', payload).then(() => {
                //         if (elData.type === "QR_CODE_ELEMENT") {
                //             qrSvg(elData.content, elData.frontColor, elData.backColor, elData.width, elData.id);
                //         }
                //     });
                    
                //     this.pageToInsert = null;
                //     this.showModal = false;
                // });
                // this.$store.dispatch('SET_PLACEHOLDER_USER_INPUTS', this.elements());
                let promiseArray = elements.map(this.elementAddPromise);

                Promise.all(promiseArray).then(() => {
                    this.pageToInsert = null;
                    this.showModal = false;
                    this.$store.dispatch('SET_PLACEHOLDER_USER_INPUTS', this.elements());
                    this.$store.dispatch('ELEMENTS_CHANGING', false);
                });
            },
            elementAddPromise(element) {
                const that = this;

                return new Promise((resolve, reject) => {
                    if (that.getSessionDetails.mode === 'user') {
                        const isPlaceholderElement = Object.keys(element).includes('placeholder');

                        if (isPlaceholderElement) {
                            const isPlaceholderSet = element.placeholder.hasPlaceholder;

                            if (isPlaceholderSet) {
                                const placeholderSystemName = element.placeholder.placeholderSystemName;

                                const placeholderValue = that.getSessionDetails.placeholderValues[placeholderSystemName].value;

                                const content = placeholderValue !== null ? placeholderValue : element.content;

                                element = {
                                    ...element,
                                    content
                                }
                            }
                        }
                    }
                    const hasLockedValue = Object.keys(element).includes('isLocked');
                    const hasNewTransforms = Object.keys(element).includes('newTransforms');
                    const isLocked = hasLockedValue ? element.isLocked : false;
                    const newTransforms = hasNewTransforms ? element.newTransforms : false;

                    const elData = {
                        ...element,
                        pageId: that.getActivePageId,
                        id: uuid.v1(),
                        isLocked,
                        newTransforms
                    };
                    const payload = {
                        elData,
                        fromProject: true,
                        elementFromPage: true
                    };
                    
                    
                    that.$store.dispatch('ADD_PAGE_ELEMENT', payload).then(() => {
                        if (elData.type === "QR_CODE_ELEMENT") {
                            qrSvg(elData.content, elData.frontColor, elData.backColor, elData.width, elData.id);
                        }
                    });

                    resolve();
                });
            },
            elements() {
                const pages = this.getPages;
                let elements = [];
                pages.forEach(page => {
                    const placeholderUserInputs = page.content.elements.filter(element => element.placeholder !== undefined).filter(element => element.placeholder.hasPlaceholder === true);
                    elements = [...elements, ...placeholderUserInputs]
                });

                let placeholders = elements.map(el => ({
                    placeholderObj: el.placeholder,
                    content: el.content,
                    ids: [],
                    hasError: false,
                    errorMessage: null
                }));
                
                placeholders = placeholders.map(placeholder => {
                    const placeholderSystemName = placeholder.placeholderObj.placeholderSystemName;

                    const elementsForPlaceholders = elements.filter(el => el.placeholder.placeholderSystemName === placeholderSystemName);

                    let ids = [];
                    elementsForPlaceholders.forEach(el => ids.push(el.id));
                    
                    return {
                        ...placeholder,
                        ids
                    }
                })

                let uniquePlaceholders = placeholders.filter((el, i, arr) => {
                    return arr.findIndex(obj => obj.placeholderObj.placeholderId === el.placeholderObj.placeholderId) === i
                });

                uniquePlaceholders.map(placeholder => {
                    const newestPlaceholderValues = this.getPlaceholders.find(item => item.id === placeholder.placeholderObj.placeholderId).name;
                    placeholder.placeholderObj.placeholderName = newestPlaceholderValues;
                });

                return uniquePlaceholders;
            }
        },
        async created() {
            const headers = {
                'api-key' : 'session',
                'api-sign' : this.sessionToken.token
            }
            try {
                const project = await ProjectRepository.getProject(this.activeProjectInThemeTab, headers);

                const promises = project.data.data.pages.map(page => {
                    return ProjectRepository.getProjectPage(this.activeProjectInThemeTab, page.number, headers);
                });

                const pages = await Promise.all(promises);

                pages.forEach(page => {
                    if (page.data.data.thumbnailUrl !== null) {
                        const pageObject = {
                            thumbnailUrl: page.data.data.thumbnailUrl,
                            thumbnailWidth: page.data.data.thumbnailWidth,
                            thumbnailHeight: page.data.data.thumbnailHeight,
                            content: page.data.data.content
                        }
                        this.projectPages = [
                            ...this.projectPages,
                            pageObject
                        ]
                    }
                    
                })

                this.dataLoaded += 1;
            }
            catch (err) {
                // Handle errors
            }
        },
        components: {
            Modal
        }
    }
</script>

<style lang="scss" scoped>
    .gallery_grid {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
    }
    .gallery_grid_item {
        // width: 115px;
        // height: 155px;
        margin: 8px 8px 8px 0;
        cursor: pointer;
        position: relative;
    }
    .gallery_grid_item_img {
        height: 100%;
        border-radius: 8px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    button {
        display: inline-block;
        width: auto;
        background-color: #F5F5F5;
        border: 1px solid #F5F5F5;
        border-radius: 16px;
        color: var(--primary-color);
        padding: 6px 15px;
    }
    @media (max-width: 1200px) {
        .gallery_grid_item {
            width: 180px;
            height: 230px;
            margin: 10px auto;
        }
    }
</style>